module.exports = __webpack_public_path__ + "img/whatsApp.9ba70fba.png";